import { ApiQueryParams } from '@frontend/api-utils';
import { MultiObjectSelectInput } from '@frontend/components/basic-forms';
import { useLocale } from '@frontend/lang';
import { ProductClient } from '@frontend/product/api';
import { defaultMapWithAttributes } from '@frontend/product/badge';
import { IProduct, ProductQueryParams } from '@frontend/product/types';
import React, { useState } from 'react';

const ID = 'multi-product-select';
export interface MultiProductSelectProps {
    id?: string;
    label?: React.ReactNode;
    required?: boolean;
    onChange?: (newValue: string[]) => void;
    onChangeObject?: (newValue: IProduct[]) => void;
    value?: string[];
    searchValueOverwrite?: string;
    className?: string;
    disabled?: boolean;
    isClearable?: boolean;
    allowURLChange?: boolean;
    createEnabled?: boolean;
    queryParams?: ApiQueryParams<ProductQueryParams>;
    disableFetch?: boolean;
    subset?: string[];
    onFocus?: React.FocusEventHandler<HTMLInputElement> | undefined;
    onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
    isOpenOverwrite?: boolean;
    queryKeyOverride?: string;
}

export const MultiProductSelect = (props: MultiProductSelectProps) => {
    const { locale } = useLocale();
    const [v, cV] = useState<IProduct[]>([]);
    if (!locale) return <></>;
    return (
        <MultiObjectSelectInput<IProduct, ProductQueryParams>
            id={`${ID}${props.id && '-' + props.id}`}
            key={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Products'}
            className={props.className}
            onChange={(v: IProduct[]) => {
                props.onChange && props.onChange(v.map((prod) => prod.id));
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={{ ...props.queryParams }}
            value={props.value || v.map((product) => product.id) || []}
            searchValueOverwrite={props.searchValueOverwrite}
            isClearable={props.isClearable}
            fetch={(arg) => ProductClient.fetchProducts({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(prod: IProduct) => defaultMapWithAttributes(prod, locale)}
            disableFetch={props.disableFetch}
            disabled={props.disabled}
            multiFetch={(ids) => ProductClient.resolveProducts(ids).then((res) => res.results)}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            subset={props.subset}
            isOpenOverwrite={props.isOpenOverwrite}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: props.queryKeyOverride ?? 'product_id',
                          fetch: (id) =>
                              ProductClient.resolveProducts(id).then((res) => {
                                  return res.results;
                              })
                      }
                    : undefined
            }
        />
    );
};
